// extracted by mini-css-extract-plugin
export default {"title":"styles_title__YsvYK","table":"styles_table__zS1fv"};